/* eslint-disable no-new */
import '../components/description.js';
import CollectionGrid from '../components/svelte/CollectionGrid.svelte';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('[data-collection-grid]');

  if (container) {
    const params = new URLSearchParams(window.location.search);
    const query = params.get('q') || '';
    const collection = JSON.parse(container.dataset.collectionGrid || null);
    const pages = JSON.parse(container.dataset.searchResults || null);

    new CollectionGrid({
      target: container,
      props: {
        collection,
        query,
        pages,
      },
    });
  }
});
